import React, {useEffect, useState} from 'react';
import {InputGroup, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button} from 'reactstrap';
import {getTwitterPreviewForEntity} from 'utils/api';
import {toast} from 'react-toastify';
import Info from '../modals/TwitterInfo';
import '../../CreateFeed/Inputs/Info.scss';
import Loader from 'components/Loader';
import SpinnerButton from 'components/SpinnerButton';

const arrayLanguage = [
    'French',
    'Spanish',
    'German',
    'Arabic',
    'Chinese',
    'Danish',
    'Dutch',
    'Greek',
    'Hebrew',
    'Hindi',
    'Italian',
    'Japanese',
    'Korean',
    'Norwegian',
    'Persian',
    'Portuguese',
    'Russian',
    'Swedish',
    'Thai',
    'Ukrainian',
    'Vietnamese',
];

const operatorsArray = [
    'Twitter Account',
    'Keyword',
    'Mentions',
    'Hashtag',
    'Cashtag',
];

const getPlaceholderForOperators = (operator) => {
    switch(operator) {
        case 'Twitter Account':
            return 'Follow a Twitter account';
        case 'Keyword':
            return 'Search twitter';
        case 'Mentions':
            return 'Follow mentions';
        case 'Hashtag':
            return 'Follow Hashtag';
        case 'Cashtag':
            return 'Follow Cashtag';
        default:
            return 'Search Twitter';
    }
};

const getOperatorType = (operator) => {
    switch(operator) {
        case 'Twitter Account':
            return 'account';
        case 'Keyword':
            return 'keyword';
        case 'Mentions':
            return 'mention';
        case 'Hashtag':
            return 'hashtag';
        case 'Cashtag':
            return 'cashtag';
        default:
            return '';
    }
};


const AddTwitterSourceInput = ({activeEntityId, addSourceToEntity}) => {
    const [fetchingContent, setFetchingContent] = useState(false);
    const [language, setLanguage] = useState('English');
    const [operator, setOperator] = useState('Twitter Account');
    const [inputValue, setInputValue] = useState('');
    const [langDropdownOpen, setLangDropdownOpen] = useState(false);
    const [operatorDropdownOpen, setOperatorDropdownOpen] = useState(false);

    const toggleLangDropdown = () => setLangDropdownOpen(prevState => !prevState);
    const toggleOperatorDropdown = () => setOperatorDropdownOpen(prevState => !prevState);

    useEffect(() => {
        if(langDropdownOpen) {
            window.addEventListener('keydown', (e) => {
                if(e.key.toLowerCase().match(/[a-z]/i)) {
                    let element = document.querySelector('#' + e.key.toLowerCase());
                    if(element) {
                        element.scrollIntoView({behavior: 'smooth', block: 'center'});
                    }
                }
            });
        }
    }, [langDropdownOpen]);

    const handleSearchChange = (e) => {
        if(e.key === 'Enter') {
            if(e.target.value.trim()) {
                fetchTwitterContent();
            }
        } else {
            setInputValue(e.target.value);
        }
    };

    const fetchTwitterContent = async() => {
        try {
            setFetchingContent(true);
            const params = {
                keyword: inputValue ? inputValue.trimEnd() : '',
                type: getOperatorType(operator),
                lang: langTransform(language),
                entityId: parseInt(activeEntityId),
            };
            let data = await getTwitterPreviewForEntity(params);
            addSourceToEntity(data.content, 'twitter');
            setInputValue('');
            toast.info('Source successfully added');
            setFetchingContent(false);
        } catch(err) {
            console.log(err);
            setFetchingContent(false);
            if(err.errors && err.errors.keyword) {
                toast.error(err.errors.keyword[0].message);
            } else if(err.message && err.message.length < 150) {
                if(err.message === 'No such user found.') {
                    toast.error('User not found');
                } else {
                    toast.error(err.message);
                }
            }
        }
    };

    const langTransform = (lang) => {
        switch(lang) {
            case 'English':
                return 'en';
            case 'Spanish':
                return 'es';
            case 'German':
                return 'de';
            case 'French':
                return 'fr';
            case 'Arabic':
                return 'ar';
            case 'Chinese':
                return 'zh';
            case 'Danish':
                return 'da';
            case 'Dutch':
                return 'nl';
            case 'Greek':
                return 'el';
            case 'Hebrew':
                return 'iw';
            case 'Hindi':
                return 'hi';
            case 'Italian':
                return 'it';
            case 'Japanese':
                return 'ja';
            case 'Korean':
                return 'ko';
            case 'Norwegian':
                return 'no';
            case 'Persian':
                return 'fa';
            case 'Portuguese':
                return 'pt';
            case 'Russian':
                return 'ru';
            case 'Swedish':
                return 'sv';
            case 'Thai':
                return 'th';
            case 'Ukrainian':
                return 'uk';
            case 'Vietnamese':
                return 'vi';
            default:
                return 'en';
        }
    };

    return (
        <div className="w-100">
            <div className="d-flex">
                <InputGroup className="d-flex flex-column justify-content-between">
                    <div className="d-flex justify-content-between w-100" style={{zIndex: '1'}}>
                        <div className="position-relative w-100">
                            <i className="fab fa-twitter-square add-entity-source-input-icon" style={{color: '#1DA1F2'}}/>
                            <Input
                                onKeyPress={(e) => handleSearchChange(e)}
                                onChange={(e) => handleSearchChange(e)}
                                value={inputValue}
                                placeholder={getPlaceholderForOperators(operator)}
                                type="text"
                                className="create-fetch_input"
                                style={{padding: '0 35px'}}
                                autoComplete="off"
                            />
                            {inputValue && inputValue.trim() && (
                                <i
                                    onClick={() => setInputValue('')}
                                    className="fa fa-times-circle position-absolute"
                                    style={{
                                        cursor: 'pointer',
                                        right: '0',
                                        top: '0',
                                        padding: '10.5px',
                                    }}
                                />
                            )}
                        </div>
                        {/*<Button*/}
                        {/*    className="calltoaction-button"*/}
                        {/*    style={{marginLeft: '10px', lineHeight: '0', minWidth: '75px'}}*/}
                        {/*    onClick={fetchTwitterContent}*/}
                        {/*    disabled={!inputValue.trim() || fetchingContent}*/}
                        {/*>*/}
                        {/*    {fetchingContent ?*/}
                        {/*        <div className="flex-centered">*/}
                        {/*            /!*<i className="fa fa-spinner fa-spin"/>*!/*/}
                        {/*            <Loader/>*/}
                        {/*        </div>*/}
                        {/*        :*/}
                        {/*        <React.Fragment>*/}
                        {/*            <span style={{fontSize: '14px '}}>*/}
                        {/*                <i style={{display: 'inline'}}*/}
                        {/*                   className="fas fa-plus"/></span>&nbsp;*/}
                        {/*            <span style={{fontSize: '16px'}}>Add</span>*/}
                        {/*        </React.Fragment>*/}
                        {/*    }*/}
                        {/*</Button>*/}
                        <div style={{marginLeft: '10px'}}>
                            <SpinnerButton
                                minWidth="75px"
                                title="Add"
                                iconClass="fas fa-plus"
                                submitting={fetchingContent}
                                onClick={fetchTwitterContent}
                            />
                        </div>
                    </div>
                    <div className="d-flex">
                        <Info/>
                        <div>
                            <Dropdown isOpen={operatorDropdownOpen} toggle={toggleOperatorDropdown}
                                      style={{marginLeft: '10px'}}>
                                <DropdownToggle
                                    className="twitter_language-dropdown-toggle btn btn-secondary"
                                    caret
                                >
                                    <div className="w-100">{operator}</div>
                                </DropdownToggle>
                                <DropdownMenu className="lang-dropdown-items" id="lang-dropdown">
                                    {operatorsArray.map(item =>
                                        (operator !== item) &&
                                        <DropdownItem
                                            style={{height: 'auto'}}
                                            onClick={(e) => setOperator(e.target.value)}
                                            key={item}
                                            value={item}
                                            id={item[0].toLowerCase()}
                                        >
                                            {item}
                                        </DropdownItem>,
                                    )}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        <div>
                            <Dropdown isOpen={langDropdownOpen} toggle={toggleLangDropdown}>
                                <DropdownToggle
                                    className="twitter_language-dropdown-toggle btn btn-secondary"
                                    caret
                                >
                                    <div style={{width: '100%'}}>{language}</div>
                                </DropdownToggle>
                                <DropdownMenu className="lang-dropdown-items" id="lang-dropdown">
                                    <DropdownItem
                                        style={{height: 'auto'}}
                                        onClick={(e) => setLanguage(e.target.value)}
                                        value="English"
                                        id="e"
                                    >
                                        English
                                    </DropdownItem>
                                    {arrayLanguage.sort().map((lang) =>
                                        (language !== lang) &&
                                        <DropdownItem
                                            style={{height: 'auto'}}
                                            onClick={(e) => setLanguage(e.target.value)}
                                            key={lang}
                                            value={lang}
                                            id={lang[0].toLowerCase()}
                                        >
                                            {lang}
                                        </DropdownItem>,
                                    )}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                </InputGroup>
            </div>
        </div>
    );
};

export default AddTwitterSourceInput;
